import script from "./DelAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./DelAccount.vue?vue&type=script&setup=true&lang=js"

import "./DelAccount.vue?vue&type=style&index=0&id=042012bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042012bc"]])

export default __exports__